import {get, post, postJson, formatUrl, patch, patchJson} from '../../../utils/request'
import {
  CHANGE_PASSWORD,
  LIST_SECURITY_QUESTIONS,
  CURRENT_SECURITY_QUESTION,
  UPDATE_CURRENT_SECURITY_QUESTION,
  NOTIFICATION_SETTINGS
} from '../../../utils/urls'

const actions = {
  changePasswordUser: async (context, payload) => {
    await post(CHANGE_PASSWORD, payload.params)
  },
  fetchListSecurityQuestions: async (context, payload) => {
    try {
      let response = await get(LIST_SECURITY_QUESTIONS)
      let status = response.status
      if (status === 200) {
        context.commit('setListSecurityQuestions', response.data['results'])
      }
    } catch (e) {
      context.commit('setListSecurityQuestions', [])
    }
  },
  fetchCurrentSecurityQuestion: async (context, payload) => {
    try {
      let response = await get(CURRENT_SECURITY_QUESTION, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setCurrentSecurityQuestion', response.data['results'])
      }
    } catch (e) {
      context.commit('setCurrentSecurityQuestion', [])
    }
  },
  saveSecurityQuestionsSettings: (context, payload) => {
    if (payload.method && payload.method.isUpdate) {
      const url = formatUrl(UPDATE_CURRENT_SECURITY_QUESTION, payload.params)
      return patchJson(url, payload.body)
    }
    return postJson(CURRENT_SECURITY_QUESTION, payload.body)
  },
  fetchNotificationSettings: async (context, payload) => {
    try {
      const url = formatUrl(NOTIFICATION_SETTINGS, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setNotificationSettings', response.data)
      }
    } catch (e) {
      context.commit('setNotificationSettings', {})
    }
  },
  updateNotificationSettings: (context, payload) => {
    const url = formatUrl(NOTIFICATION_SETTINGS, payload.params)
    return patch(url, payload.body)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/settings/actions.js